// CustomerList.jsx
import React, { useEffect, useState } from "react";
import api from "../api/axios";
import DocumentViewer from "../components/modal/DocumentViewer";
import { Modal } from "react-bootstrap";
import LedgerAutoForm from "../components/forms/LedgerAutoForm";

function CustomerList() {
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("accessToken");
  const branch_id = sessionStorage.getItem("selectedContext")
        ? JSON.parse(sessionStorage.getItem("selectedContext")).branch
        : 0;

  // NEW: Document Viewer States
  const [showDocs, setShowDocs] = useState(false);
  const [docClientId, setDocClientId] = useState(null);
  const [docClientName, setDocClientName] = useState("");

  const [showLedgerModal, setShowLedgerModal] = useState(false);
  const [selectedCompanyName, setSelectedCompanyName] = useState("");
  const [selectedMasterId, setSelectedMasterId] = useState("");

  useEffect(() => {
    const fetchTenants = async () => {
      try {
        const res = await api.get(`/customer-list?branch_id=${branch_id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setTenants(res.data.data || []);
      } catch (err) {
        console.error("Error fetching tenants:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTenants();
  }, [token]);

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const d = new Date(dateStr);
    return `${d.getDate().toString().padStart(2, "0")}-${(d.getMonth()+1)
      .toString()
      .padStart(2, "0")}-${d.getFullYear()}`;
  };

  // NEW: Open Document Viewer
  const handleViewDocuments = (clientId, clientName) => {
    setDocClientId(clientId);
    setDocClientName(clientName);
    setShowDocs(true);
  };

  const openLedgerModal = (companyName, userId) => {
    setSelectedCompanyName(companyName);
    setSelectedMasterId(userId);
    setShowLedgerModal(true);
  };

  return (
    <>
      {/* Page Header */}
      <div className="row">
          <div className="col-12">
            <div className="page-title-box d-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0">Customers/Tenants</h4>
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a href="#">Accounts</a>
                  </li>
                  <li className="breadcrumb-item active">Customers/Tenants</li>
                </ol>
              </div>
            </div>
          </div>
      </div>

      {/* Card */}
      <div className="card">
        <div className="card-header">
          <h4 className="card-title mb-0">Customer / Tenant List</h4>
        </div>
        <div className="card-body">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped ledger-table">
                <thead>
                  <tr>
                    <th>Company Name</th>
                    <th>Office</th>
                    <th>Contract Start (Period)</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {tenants.length > 0 ? (
                    tenants.map((tenant) => { console.log(tenant);
                      const onboard = tenant.tenant_onboard_linking?.[0]?.onboard;
                      const office = tenant.office_data?.office_no || "-";
                      const startDate = onboard?.contarct_start_date
                                          ? new Date(onboard.contarct_start_date)
                                          : null;                    
                      const contractPeriod = onboard?.contarct_period || 0;
                      const status = onboard?.status == 3 ? "Active" : "Pending";

                        return (
                        <tr key={tenant.id}>
                          <td>{tenant.company_name}</td>
                          <td>{office}</td>
                          <td>
                          {startDate
                            ? `${formatDate(startDate)} (${contractPeriod} months)`
                            : "-"}
                          </td>
                          <td>
                          <span className="badge bg-success">{status}</span>
                          </td>
                          <td>
                          <button
                            className="btn btn-primary btn-sm me-2"
                            onClick={() =>
                            handleViewDocuments(onboard?.id, onboard?.company_name)
                            }
                          >
                            Files
                          </button>
                          <a
                            href={`/client-checks/${onboard?.id}`}
                            target="_blank"
                            className="btn btn-primary btn-sm me-1"
                          >
                            Payment Info
                          </a>
                          {tenant.has_ledger == false && (
                            <a
                            href="#"
                            className="btn btn-info btn-sm"
                            onClick={() => openLedgerModal(tenant.company_name, tenant.user_id)}
                            >
                            Generate Ledger
                            </a>
                          )}
                          </td>
                        </tr>
                        );
                    })
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No data found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      <DocumentViewer
          clientId={docClientId}
          clientName={docClientName}
          show={showDocs}
          onClose={() => setShowDocs(false)}
      />

      <Modal
        show={showLedgerModal}
        onHide={() => setShowLedgerModal(false)}
        size="lg"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Create Ledger</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <LedgerAutoForm
            prefillName={selectedCompanyName}
            prefillMasterId={selectedMasterId}
            onSuccess={() => {
              setShowLedgerModal(false);
            }}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}

export default CustomerList;